// All "public" types visible to widgets
// Global version of this set of api contracts, use this in the target version of all tryGetApi requests
let widgetApiVersion = 1;
export default widgetApiVersion;
;
export var WidgetForceRefreshUnify1SCallVerb;
(function (WidgetForceRefreshUnify1SCallVerb) {
    WidgetForceRefreshUnify1SCallVerb["modifyUrl"] = "modifyUrl";
    WidgetForceRefreshUnify1SCallVerb["refresh"] = "refresh";
})(WidgetForceRefreshUnify1SCallVerb || (WidgetForceRefreshUnify1SCallVerb = {}));
// The RefreshContent Task Status
// 0 Failed
// 1 Succeed
// 2 Running
export var RefreshContentTaskStatus;
(function (RefreshContentTaskStatus) {
    RefreshContentTaskStatus[RefreshContentTaskStatus["Failed"] = 0] = "Failed";
    RefreshContentTaskStatus[RefreshContentTaskStatus["Succeed"] = 1] = "Succeed";
    RefreshContentTaskStatus[RefreshContentTaskStatus["Running"] = 2] = "Running";
})(RefreshContentTaskStatus || (RefreshContentTaskStatus = {}));
/**
 * Prong2 Cache module background task status enums
 */
export const BackgroundTaskStatus = {
    Disabled: "0",
    Running: "1",
    Suspended: "2",
};
